module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/de787f0af75a8a6da1e40057c7b01199.png";